import { render, staticRenderFns } from "./ShphMasseuseTime.vue?vue&type=template&id=3608ccc2&scoped=true&"
import script from "./ShphMasseuseTime.vue?vue&type=script&lang=js&"
export * from "./ShphMasseuseTime.vue?vue&type=script&lang=js&"
import style0 from "./ShphMasseuseTime.vue?vue&type=style&index=0&id=3608ccc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608ccc2",
  null
  
)

export default component.exports